import styled from '@emotion/styled';
import { Pagination } from '@blueprint/ui';
import { css } from '@emotion/react';

const LSRP_SIDEBAR_MEDIA_QUERY = `@media only screen and (min-width: 1140px)`;

export const getRems = (pixels: number) => {
    return `${pixels / 16}rem`;
};

const SearchResultsWrapper = styled.div(
    ({ theme: { colors } }) => css`
        width: 100%;
        margin: 0 auto;
        background-color: ${colors['graphic-background']};
    `
);

const InnerWrapper = styled.div(
    ({ theme: { spacing, mq, pageWidth } }) => css`
        margin: 0 auto;
        padding: ${spacing['8px']} 0;

        ${mq.medium} {
            padding: ${spacing['24px']} 0;
        }
        padding: ${spacing['24px']} 0;
        max-width: calc(${pageWidth}px + (2 * ${spacing['32px']}));

        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            display: flex;
        }
    `
);

const DesktopSubHeaderWrapper = styled.div<{ isStickyDesktopBar: boolean }>(
    ({ isStickyDesktopBar, theme: { colors, spacing } }) => css`
        max-width: 1265px;
        color: ${colors['white']};
        display: none;
        padding: ${isStickyDesktopBar ? 0 : `${spacing['16px']} 0`};
        align-items: center;
        justify-content: center;
        margin: auto;

        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            display: flex;
        }
    `
);

export const SearchInputWrapper = styled.div(
    ({ theme: { spacing, pageWidth } }) => css`
        padding: 0;
        display: flex;
        width: 100%;
        max-width: calc(${pageWidth}px + (2 * ${spacing['32px']}));
        padding-right: ${spacing['32px']};
    `
);

const SideBar = styled.aside<{ isStickyDesktopBar: boolean }>(
    ({ isStickyDesktopBar, theme: { spacing, mq } }) => css`
        display: block;
        min-width: ${getRems(299)};
        padding-left: ${spacing['16px']};

        ${mq.large} {
            padding-left: ${spacing['32px']};
        }

        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            display: flex;
            flex-wrap: wrap;
            align-items: flex-start;
            align-content: flex-start;
            padding: 0;
            max-width: ${getRems(300)};
        }

        ${isStickyDesktopBar &&
        `[id^="adbridg_ad_adb_skyscraper_"] {
            top: 160px !important;
        }`}
    `
);

const SectionThatAppearsWhenNoSideBar = styled.div(
    () => css`
        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            display: none;
        }
    `
);

const SearchResultsLayoutGroup = styled.div(
    ({ theme: { spacing, mq } }) => css`
        margin-bottom: ${spacing['16px']};

        ${mq.large} {
            margin-bottom: ${spacing['24px']};
        }

        @media only screen and (min-width: 1140px) {
            padding-right: ${spacing['32px']};
        }
    `
);

const PaginationContainer = styled.div(
    ({ theme: { spacing } }) => css`
        display: flex;
        justify-content: center;
        margin-top: ${spacing['24px']};
    `
);

const StyledPagination = styled(Pagination)(
    () => css`
        flex-grow: 1;
    `
);

const StyledMobileQuickSearchBar = styled.div(
    ({ theme: { spacing } }) => css`
        display: flex;
        padding-top: ${spacing['8px']};
    `
);

// TODO: alias box-shadow to fixed
const StickyQuickSearchBarDynamicShadow = styled.div(
    ({ theme: { boxShadow } }) => css`
        height: 5rem;
        position: sticky;
        top: -1rem;
        z-index: 4;
        text-align: center;

        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            display: none;
        }

        &::before,
        &::after {
            content: '';
            display: block;
            height: 1rem;
            position: sticky;
        }

        &::before {
            top: 3rem;
            box-shadow: ${boxShadow['200']};
        }
    `
);

const StickyQuickSearchBarWrapper = styled.nav(
    ({ theme: { colors, spacing } }) => css`
        background-color: ${colors['graphic-background']};
        height: 4rem;
        padding-bottom: ${spacing['8px']};
        position: sticky;
        top: 0;
        margin-top: -1rem;
        z-index: 6;

        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            display: none;
        }
    `
);

const StickyDesktopSubHeaderDynamicShadow = styled.div(
    ({ theme: { boxShadow } }) => css`
        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            height: 6.7rem;
            position: sticky;
            top: -0.5rem;
            background: #ffffff;

            z-index: 99;

            &::before,
            &::after {
                content: '';
                display: block;
                height: 2rem;
                position: sticky;
            }

            &::before {
                top: 7.8rem;
                box-shadow: ${boxShadow['200']};
            }
        }
    `
);

const StickyDesktopSubHeaderWrapper = styled.div(
    ({ theme: { colors, spacing } }) => css`
        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            background-color: ${colors['graphic-background']};
            height: 5rem;
            padding-bottom: ${spacing['8px']};
            position: sticky;

            margin-top: -1rem;
            z-index: 101;
        }
    `
);

const LocationWrapper = styled.div(
    () => css`
        flex-grow: 1;
        min-width: 0;
    `
);

export {
    SearchResultsWrapper,
    SideBar,
    SectionThatAppearsWhenNoSideBar,
    DesktopSubHeaderWrapper,
    InnerWrapper,
    SearchResultsLayoutGroup,
    PaginationContainer,
    StyledPagination,
    StyledMobileQuickSearchBar,
    LocationWrapper,
    StickyQuickSearchBarWrapper,
    StickyQuickSearchBarDynamicShadow,
    StickyDesktopSubHeaderDynamicShadow,
    StickyDesktopSubHeaderWrapper
};
